import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteBaixaManualEstoqueProducao } from '../service';
import {
  DELETE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO,
  DELETE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_PENDING,
  DELETE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS,
  DELETE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_FAILURE,
} from '../actionTypes';

import { AlertError, AlertWarning } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteBaixaManualEstoqueProducao(action) {
  yield put({ type: DELETE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.BAIXA_MANUAL_ESTOQUE_AGRICOLA_EXCLUIR);

  try {
    const a = yield call(deleteBaixaManualEstoqueProducao, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteBaixaManualEstoqueProducao() {
  yield takeLatest(DELETE_BAIXAR_MANUAL_ESTOQUE_PRODUCAO, sagaDeleteBaixaManualEstoqueProducao)
}
